<div class="flex flex-col gap-2 px-2 mb-10">
    <div class="header">
        <div class="flex justify-between px-4 py-3 items-center">
            <div class="flex gap-2 items-center">
                <i class="pi pi-arrow-left back-button text-black cursor-pointer" (click)="navigateBackUrl()">
                </i>
                <h1 class="text-black font-bold text-2xl">Checkout</h1>
            </div>
            <img class="logo w-26 h-16 cursor-pointer" routerLink="dashboard"
                src="https://images.mashhoorplus.in/file/mashhoor-plus.png" alt="Mashhoor Plus Logo">
        </div>
    </div>
    <hr class="h-1 my-2">

    <div *ngIf="orderPlaced" class="order-success-container">

        <div *ngIf="orderMetaData">
            <!-- Success Header -->
            <div class="success-header">
                <div class="success-icon-wrapper">
                    <i class="pi pi-check-circle success-icon"></i>
                </div>
                <h1 class="success-title">Order Placed Successfully!</h1>
                <p class="success-subtitle">Thank you for your order. We'll send you a confirmation email shortly.</p>
                <div class="order-date">
                    <i class="pi pi-calendar"></i>
                    <span>{{ orderMetaData.created_on | date:'medium' }}</span>
                </div>
            </div>

            <!-- Order Summary Card -->
            <div class="order-summary-card">
                <div class="card-header">
                    <h2>Order Summary</h2>
                    <span class="order-status">{{ orderMetaData.status | titlecase }}</span>
                </div>

                <!-- Products List -->
                <div class="products-section">
                    <h3>Items Ordered ({{ orderMetaData.summary.total_items }})</h3>
                    <div *ngFor="let product of orderMetaData.products" class="product-item">
                        <div class="product-image">
                            <img [src]="product.main_image" [alt]="product.title" />
                        </div>
                        <div class="product-details">
                            <h4>{{ product.title }}</h4>
                            <div class="product-meta">
                                <span class="quantity">Qty: {{ product.quantity }}</span>
                                <span class="weight">Weight: {{ product.weight }}kg</span>
                                <span class="gst">GST: {{ product.gst }}%</span>
                            </div>
                            <div class="price-section">
                                <span class="original-price" *ngIf="product.unit_price !== product.discounted_price">
                                    ₹{{ product.unit_price }}
                                </span>
                                <span class="discounted-price">₹{{ product.discounted_price }}</span>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Price Breakdown -->
                <div class="price-breakdown">
                    <div class="price-row">
                        <span>Subtotal</span>
                        <span>₹{{ orderMetaData.summary.subtotal }}</span>
                    </div>
                    <div class="price-row discount-row" *ngIf="orderMetaData.summary.totalDiscount > 0">
                        <span>Discount</span>
                        <span class="discount-amount">-₹{{ orderMetaData.summary.totalDiscount }}</span>
                    </div>
                    <div class="price-row">
                        <span>Shipping</span>
                        <span>{{ orderMetaData.summary.shippingCost === 0 ? 'FREE' : '₹' +
                            orderMetaData.summary.shippingCost }}</span>
                    </div>
                    <div class="price-row">
                        <span>Tax</span>
                        <span>₹{{ orderMetaData.summary.tax }}</span>
                    </div>
                    <div class="price-row total-row">
                        <span>Total</span>
                        <span>₹{{ orderMetaData.summary.total }}</span>
                    </div>
                </div>
            </div>

            <!-- Delivery Information -->
            <div class="delivery-info-card">
                <div class="card-header">
                    <h2><i class="pi pi-map-marker"></i> Delivery Information</h2>
                </div>
                <div class="address-details">
                    <div class="recipient-name">{{ orderMetaData.address_info.receiver_name }}</div>
                    <div class="address-lines">
                        <p>{{ orderMetaData.address_info.address_line }}</p>
                        <p *ngIf="orderMetaData.address_info.apartment_no">Apartment: {{
                            orderMetaData.address_info.apartment_no }}</p>
                        <p>{{ orderMetaData.address_info.city }}, {{ orderMetaData.address_info.state }}</p>
                        <p>{{ orderMetaData.address_info.country }} - {{ orderMetaData.address_info.pincode }}</p>
                    </div>
                    <div class="contact-info">
                        <div class="contact-item">
                            <i class="pi pi-phone"></i>
                            <span>{{ orderMetaData.address_info.phone }}</span>
                        </div>
                        <div class="contact-item">
                            <i class="pi pi-envelope"></i>
                            <span>{{ orderMetaData.address_info.email }}</span>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Payment Information -->
            <div class="payment-info-card">
                <div class="card-header">
                    <h2><i class="pi pi-credit-card"></i> Payment Information</h2>
                </div>
                <div class="payment-details">
                    <!-- <div class="payment-method">
        <span class="method-label">Payment Method:</span>
        <span class="method-value cod-badge">Cash on Delivery</span>
      </div> -->
                    <div class="order-notes" *ngIf="orderMetaData.order_notes">
                        <span class="notes-label">Notes:</span>
                        <span class="notes-value">{{ orderMetaData.order_notes }}</span>
                    </div>
                </div>
            </div>

        </div>

        <!-- Action Buttons -->
        <!-- <div class="action-buttons">
            <button class="btn btn-primary">
                <i class="pi pi-eye"></i>
                Track Order
            </button>
            <button class="btn btn-secondary">
                <i class="pi pi-download"></i>
                Download Receipt
            </button>
            <button class="btn btn-outline">
                <i class="pi pi-shopping-cart"></i>
                Continue Shopping
            </button>
        </div> -->
    </div>

    <div *ngIf="!cartCounts" class="w-full flex flex-col gap-8 border-2 p-5 text-center">
        <p class="text-2xl">Your Cart is Empty for Checkout</p>
        <i class=" pi pi-shopping-cart text-5xl"></i>
    </div>
    <!-- 
    <div *ngIf="errorBannerMessage.length>0">
        <p-messages [(value)]="errorBannerMessage" [closable]="false" />
    </div> -->

    <div *ngIf="cartCounts && !orderPlaced" class="order-summary flex flex-col md:flex-row flex-wrap">
        <div class="md:w-1/2 px-4">
            <div class="checkout text-center mt-5  md:relative fixed bottom-2 left-0 z-10 w-full px-2">
                <div *ngIf="errorBannerMessage.length>0">
                    <p-messages [(value)]="errorBannerMessage" [closable]="false" />
                </div>
                <button *ngIf="cartSummary?.total" (click)="createOrder()" class="bg-primary text-white font-bold py-3 px-4 w-full
                       transition duration-500 ease-in-out
                       hover:scale-101 hover:-translate-y-1 rounded-lg">

                    {{buttonText}}
                    <span *ngIf="paymentMode=='P'" class="line-through text-white text-xs">
                        &nbsp;{{ cartSummary.subtotal }}
                    </span>
                </button>

            </div>
            <hr class="h-1">

            <div class="deliver-to-container md:max-w-3xl mx-auto p-2">
                <!-- Header Section -->
                <!-- <div class="text-center mb-8">
                    <h1 class="text-3xl font-bold text-gray-900 mb-2">Deliver To</h1>
                    <p class="text-gray-600">Select your delivery address</p>
                </div> -->

                <!-- Address Selection Section -->
                <div *ngIf="!showAddressForm" class="space-y-4">

                    <!-- Address Cards -->
                    <div class="grid gap-4">
                        <div *ngFor="let address of addresses;" [ngClass]="{
          'border-primary border-2 bg-primary-light': selectedAddressId === address.id,
          'border-gray-200 border hover:border-gray-300': selectedAddressId !== address.id
        }" class="address-card rounded-xl shadow-sm p-5 bg-white cursor-pointer transition-all duration-200 hover:shadow-md relative"
                            (click)="selectAddress(address.id)">

                            <!-- Selected Indicator -->
                            <div *ngIf="selectedAddressId === address.id"
                                class="absolute top-4 right-4 w-6 h-6 bg-primary rounded-full flex items-center justify-center">
                                <svg class="w-4 h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                        d="M5 13l4 4L19 7"></path>
                                </svg>
                            </div>

                            <!-- Address Content -->
                            <div class="pr-8">
                                <!-- Header Row -->
                                <div class="flex justify-between items-start mb-3">
                                    <div class="flex-1">
                                        <h3 class="text-lg font-semibold text-gray-900 mb-1">
                                            {{ address.receiver_name }}
                                        </h3>
                                        <div class="flex items-center text-gray-600">
                                            <svg class="w-4 h-4 mr-1" fill="none" stroke="currentColor"
                                                viewBox="0 0 24 24">
                                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                                    d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z">
                                                </path>
                                            </svg>
                                            <span class="text-sm font-medium">+91 {{ address.phone }}</span>
                                        </div>
                                    </div>
                                </div>

                                <!-- Address Details -->
                                <div class="mb-4">
                                    <div class="flex items-start text-gray-700 mb-2">
                                        <svg class="w-4 h-4 mr-2 mt-0.5 text-gray-500" fill="none" stroke="currentColor"
                                            viewBox="0 0 24 24">
                                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                                d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z">
                                            </path>
                                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                                d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"></path>
                                        </svg>
                                        <div class="flex-1">
                                            <p class="text-sm leading-relaxed">
                                                <span *ngIf="address.apartment_no" class="inline">{{
                                                    address.apartment_no }}, </span>
                                                {{ address.address_line }}<br>
                                                {{ address.city }}, {{ address.state }} {{ address.pincode }}
                                            </p>
                                        </div>
                                    </div>
                                </div>

                                <!-- Default Badge -->
                                <div class="flex items-center justify-between">
                                    <span *ngIf="address.is_default"
                                        class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800">
                                        <svg class="w-3 h-3 mr-1" fill="currentColor" viewBox="0 0 20 20">
                                            <path fill-rule="evenodd"
                                                d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                                                clip-rule="evenodd"></path>
                                        </svg>
                                        Default
                                    </span>

                                    <!-- Edit Button -->
                                    <button (click)="updateAddress(address); $event.stopPropagation()"
                                        class="inline-flex items-center px-2.5 py-1.5 text-xs font-medium text-gray-600 hover:text-primary hover:bg-primary-light rounded-lg transition-colors duration-150"
                                        title="Edit Address">
                                        <svg class="w-3.5 h-3.5 mr-1" fill="none" stroke="currentColor"
                                            viewBox="0 0 24 24">
                                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                                d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z">
                                            </path>
                                        </svg>
                                        Edit
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Add Address Button -->
                    <div *ngIf="isUserLoggedin" class="text-center pt-6 mb-5">
                        <button type="button" (click)="addNewAddress()" [disabled]="loading"
                            class="inline-flex items-center px-6 py-3 border border-transparent text-sm font-medium rounded-lg text-white bg-primary hover:bg-primary-light focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary disabled:opacity-50 disabled:cursor-not-allowed shadow-sm transition-colors duration-150">
                            <svg class="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                    d="M12 6v6m0 0v6m0-6h6m-6 0H6"></path>
                            </svg>
                            <span *ngIf="!loading">Add New Address</span>
                            <span *ngIf="loading" class="flex items-center">
                                <svg class="animate-spin -ml-1 mr-2 h-4 w-4 text-white"
                                    xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                    <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor"
                                        stroke-width="4"></circle>
                                    <path class="opacity-75" fill="currentColor"
                                        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z">
                                    </path>
                                </svg>
                                Adding...
                            </span>
                        </button>
                    </div>


                    <!-- Selected Address Summary (Optional) -->
                    <!-- <div *ngIf="selectedAddressId" class="mt-8 p-4 bg-primary-light border border-primary rounded-lg">
                        <div class="flex items-center">
                            <svg class="w-5 h-5 text-primary mr-2" fill="none" stroke="currentColor"
                                viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                    d="M5 13l4 4L19 7"></path>
                            </svg>
                            <span class="text-sm font-medium text-white">Delivery address selected</span>
                        </div>
                    </div> -->
                </div>
                <div *ngIf="showAddressForm">
                    <app-address-form (closeAddressForm)="closeForm()" [minimal]="true"
                        [selectedAddress]="addressToEdit" (updatedAddress)="updateAddresses($event)">
                    </app-address-form>
                </div>

                <div class="default-checkbox flex flex-row my-2">
                    <input type="checkbox" id="sameAsBilling" [(ngModel)]="sameAsBilling"
                        (change)="onSameAsBillingChange()" class="mr-2">
                    <p class="text-sm mx-1"> Deliivery Address is same as billing address</p>

                </div>

            </div>
            <hr class="h-1 my-2">
            <!-- <div class=" flex flex-col justify-center p-5 w-full gap-5">
                <p class="text-secondary text-2xl uppercase text-center">Payments are Secured With</p>
                <img class="w-32 h-32 self-center" style="mix-blend-mode: multiply;" [src]="razorpayImg"
                    alt="RazorpayLogo">
            </div> -->

        </div>
        <div class="md:w-1/2">


            <p class="text-3xl my-2 text-center antialiased text-black font-bold">Order Summary</p>
            <div class="overflow-y-auto max-h-screen">
                <app-cart [minimal]="true"></app-cart>
            </div>
            <div class="order-summary-container flex flex-col justify-center gap-5">
                <app-order-summary (paymentSummary)="updateCartSummary($event)"></app-order-summary>
            </div>
        </div>
    </div>


</div>

<!-- Updated parent component with responsive dialog positioning -->
<p-dialog [closable]="false" [position]="isMobile ? 'bottom' : 'center'" header="" [modal]="true"
    [(visible)]="verifyOtp" [style]="{ width: isMobile ? '100vw' : '25rem', height: isMobile ? 'auto' : 'auto' ,background: 'transparent',border: 'none', color: 'white', fontSize: '1.125rem',
    fontWeight: '600',
    textAlign: 'center',
    padding: isMobile ? '0rem' : '1rem'
  }" styleClass="otp-verify-dialog">

    <div class="otp-dialog-content">
        <app-otp-verify [isInDialog]="true" (verifyResponse)="handleVerifyOtpResponse($event)"
            *ngIf="addresses.length > 0 && addresses[0].phone" [phoneNumber]="addresses[0].phone"
            class="dialog-otp-verify">
        </app-otp-verify>
    </div>
</p-dialog>